import { CREATE_TICKET, UPDATE_TICKET } from '../store/actions/tickets';

export const MAX_REQUEST_TIME_BEFORE_ERROR = 5000;

export const ERROR = 'ERROR';
export const ERROR_TAKE_EVERY = 'ERROR_TAKE_EVERY';
export const SAVE_ERROR = 'SAVE_ERROR';

export const SAVE_CRITICAL_ERRORS = 'SAVE_CRITICAL_ERRORS';
export const RESET_CRITICAL_ERRORS = 'RESET_CRITICAL_ERRORS';

export const AUTH = 'Ошибка авторизации.';
export const AUTH_LOG_IN = 'Ошибка логина';
export const AUTH_TOKEN = 'Ошибка получения токена авторизации.';
export const AUTH_VOX = 'Ошибка авторизации в VoxImplant.';
export const AUTH_TOKEN_ROTTEN = 'Токен авторизации устарел.';
export const TIME_SYNC = 'Ошибка синхронизации времени.';

export const POPUP_TITLES = {
  [CREATE_TICKET]: 'Ошибка создания тикета',
  [UPDATE_TICKET]: 'Ошибка обновления тикета',
  DEFAULT: 'Произошла ошибка',
};

export const VOX_ERRORS = {
  MIC: 'Проверьте настройки микрофона и перезагрузите страницу',
  NOTIFICATIONS: 'Проверьте настройки уведомлений и перезагрузите страницу',
  AUTH: 'Не получается авторизоваться в телефонии',
  SDK: 'Проблема SDK Voximplant',
  STATUS: 'Проблема при обновление статуса',
  NETWORK: 'Проблема с подключением. Пробуем подключиться снова.',
  UKNOWN: 'Возникла неизвестная ошибка',
};

// Ошибка в ..
export const METHOD_TITLES = {
  subscribeSocketActiveChain: 'подписке на переписку (VPN)',
  subscribeSocketActiveTicket: 'подписке на тикет (VPN)',
  subscribeSocketChainList: 'подписке на список переписок (VPN)',
  subscribeSocketStatus: 'подписке на статус (VPN)',
  subscribeSocketTickets: 'подписке на новые тикеты (VPN)',
  subscribeTicketLogChannel: 'подписке на лог тикета (VPN)',
  unsubscribeSocketActiveChain: 'отписке на переписку (VPN)',
  unsubscribeSocketActiveTicket: 'отписке на активный тикет (VPN)',
  unsubscribeSocketChainList: 'отписке на список переписок (VPN)',
  unsubscribeTicketLogTicket: 'отписке от лога тикета (VPN)',
  sendMessageManagerBus: 'открытие заказа (LT Order Filler)',
  startTimeSyncing: 'синхронизации времени',
};

// Запрос ..
export const API_TITLES = {
  '/admin/calls': 'звонков',
  '/crm/chains': 'печати переписки',
  '/crm/v1/authorize': 'авторизации',
  '/crm/v1/call_reasons': 'причин звонка',
  '/crm/v1/call_reasons/multi': 'добавления причин звонка',
  '/crm/v1/call_reasons/reasons': 'списка причин',
  '/crm/v1/call_reasons/segments': 'сегментов звонка',
  '/crm/v1/calls': 'списка звонков',
  '/crm/v1/calls/pbx/': 'информации по PBX звонка',
  '/crm/v1/chains': 'переписка',
  '/crm/v1/communication_logs': 'лога коммуникаций',
  '/crm/v1/groups': 'групп темплейтов писем',
  '/crm/v1/mail_templates': 'темплейтов писем',
  '/crm/v1/mails': 'почты',
  '/crm/v1/mails/search': 'поиска писем',
  '/crm/v1/manager_emails': 'почты менеджеров',
  '/crm/v1/managers': 'статуса менеджера',
  '/crm/v1/messages': 'сообщений',
  '/crm/v1/messages/search': 'поиска сообщений',
  '/crm/v1/meta/time_sync': 'синхронизации времени',
  '/crm/v1/notes': 'заметок',
  '/crm/v1/orders': 'заказов клиента',
  '/crm/v1/orders/search': 'поиска заказов',
  '/crm/v1/orders/segments': 'сегментов заказа',
  '/crm/v1/partners': 'списка партнеров',
  '/crm/v1/persons': 'клиента',
  '/crm/v1/persons/current': 'информации об операторе',
  '/crm/v1/persons/mail_boxes': 'почтовых ящиков',
  '/crm/v1/persons/managers': 'списка менеджеров',
  '/crm/v1/persons/search': 'поиска клиентов',
  '/crm/v1/places/autocomplete': 'мест для автокомплита',
  '/crm/v1/places/departure_cities': 'городов прибытия',
  '/crm/v1/tags': 'списка тегов',
  '/crm/v1/ticket_logs': 'лога тикета',
  '/crm/v1/ticket_logs/search': 'поиска заметок',
  '/crm/v1/ticket_logs/notes': 'заметок для тикета',
  '/crm/v1/tickets': 'списка тикетов',
  '/crm/v1/tickets/close_reasons': 'причин закрытия тикетов',
  '/crm/v1/tickets/mail_groups': 'мэйл групп для тикетов',
  '/crm/v1/tickets/plan_reasons': 'задач для тикетов',
  '/crm/v1/tickets/reasons': 'причин для тикетов',
  '/crm/v1/tickets/sources': 'источников тикетов',
  '/crm/vox_me': 'авторизации телефонии',
  '/crm/vox_monitoring.json': 'списка операторов',
  '/crm/vox_monitoring/access_url': 'технического URL звонка',
  '/crm/vox_monitoring/client_info': 'данных о клиенте',
  '/crm/vox_monitoring/current_user_recent_calls': 'списка последних звонков',
  '/crm/vox_monitoring/open_package': 'URL пакета',
  '/crm/vox_monitoring/queues_to_transfer': 'доступных очередей телефонии',
  '/crm/vox_monitoring/log_operator_status': 'лога статуса',
};
